import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Language} from '../types/language-switcher.types';
import {environment} from '../../../../../../environments/environment';
import {LocalStorageService} from '../../../../../api/services/localStorage';
import {LoggedUser} from '../../../../types/loggedUser';

@Injectable({
    providedIn: 'root'
})
export class LanguageSwitcherService {

  loggedUser = new LoggedUser();

  public selectedLanguage: string;
  constructor(
    private translate: TranslateService,
    private localStorage: LocalStorageService
  ) {
    this.init();
  }
  private init(): void {
    if (this.localStorage.get('loggedUser') !== null) {
      this.loggedUser = this.localStorage.get('loggedUser') as LoggedUser;
      this.translate.use(this.loggedUser.language);
      this.selectedLanguage = this.loggedUser.language.toString().toUpperCase();
    } else {
      this.selectedLanguage = 'EN';
    }
    this.translate.addLangs(environment.translations.locales);
    this.translate.setDefaultLang(environment.translations.defaultLocale);
  }
  public changeLanguage(lang: MouseEvent): void {
    const example = lang.target as HTMLElement;
    switch (example.textContent) {
      case 'EN': this.translate.use(Language.EN); this.selectedLanguage = 'EN'; this.changeLanguageIfUserIsLogged(Language.EN); break;
      case 'CZ': this.translate.use(Language.CZ); this.selectedLanguage = 'CZ'; this.changeLanguageIfUserIsLogged(Language.CZ); break;
      case 'HU': this.translate.use(Language.HU); this.selectedLanguage = 'HU'; this.changeLanguageIfUserIsLogged(Language.HU); break;
      case 'PL': this.translate.use(Language.PL); this.selectedLanguage = 'PL'; this.changeLanguageIfUserIsLogged(Language.PL); break;
      case 'RO': this.translate.use(Language.RO); this.selectedLanguage = 'RO'; this.changeLanguageIfUserIsLogged(Language.RO); break;
      case 'SK': this.translate.use(Language.SK); this.selectedLanguage = 'SK'; this.changeLanguageIfUserIsLogged(Language.SK); break;
      default: this.translate.use(Language.EN); this.selectedLanguage = 'EN'; this.changeLanguageIfUserIsLogged(Language.EN); break;
    }
  }

  public changeStringLanguage(lang: string): void {
    switch (lang) {
      case 'EN': this.translate.use(Language.EN); this.selectedLanguage = 'EN'; this.changeLanguageIfUserIsLogged(Language.EN); break;
      case 'CZ': this.translate.use(Language.CZ); this.selectedLanguage = 'CZ'; this.changeLanguageIfUserIsLogged(Language.CZ); break;
      case 'HU': this.translate.use(Language.HU); this.selectedLanguage = 'HU'; this.changeLanguageIfUserIsLogged(Language.HU); break;
      case 'PL': this.translate.use(Language.PL); this.selectedLanguage = 'PL'; this.changeLanguageIfUserIsLogged(Language.PL); break;
      case 'RO': this.translate.use(Language.RO); this.selectedLanguage = 'RO'; this.changeLanguageIfUserIsLogged(Language.RO); break;
      case 'SK': this.translate.use(Language.SK); this.selectedLanguage = 'SK'; this.changeLanguageIfUserIsLogged(Language.SK); break;
      default: this.translate.use(Language.EN); this.selectedLanguage = 'EN'; this.changeLanguageIfUserIsLogged(Language.EN); break;
    }
  }
  
  changeLanguageIfUserIsLogged(language: Language): void {
    if (this.localStorage.get('loggedUser') !== null) {
      const user = this.localStorage.get('loggedUser') as LoggedUser;
      user.language = language;
      this.localStorage.set('loggedUser', user);
    }
  }
}
